import { Img } from "ui-kit/components-branded/index"
import { ServicesGroup } from "utils/helpers/ServicesGroup"
import { serviceGroupId } from "utils/helpers/serviceGroupId"

export function CardImage({
    serviceGroup,
    className,
}: {
    serviceGroup: ServicesGroup
    className?: string
}) {
    switch (serviceGroupId[serviceGroup.id]) {
        case "single":
            return (
                <Img
                    className={className}
                    src="one-person-session.svg"
                    alt="Иллюстрация личной сессии"
                />
            )
        case "family":
            return (
                <Img
                    className={className}
                    src="family-session.svg"
                    alt="Иллюстрация семейной сессии"
                />
            )
        default:
            return <Img className={className} src="girl-with-laptop.svg" alt="Иллюстрация сессии" />
    }
}
